import React from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { removeNotification } from '../../store/notifications/thunks'

import { Item } from './Item/Item'

import './Notifications.scss'

export const Notifications = () => {
  const { list } = useSelector(state => state.notifications)
  const dispatch = useDispatch()

  const remove = id => () => dispatch(removeNotification(id))

  return list.length
    ? (
      <div className="notifications-wrapper">
        <div className="list">
          {
            list.map(item => (
              <Item
                key={ item.id }
                item={ item }
                onClick={ remove(item.id) }
                onDead={ remove(item.id) }
              />
            ))
          }
        </div>
      </div>
    )
  : ''
}